import { render, staticRenderFns } from "./ProtocolDialog.vue?vue&type=template&id=a59f583a&"
import script from "./ProtocolDialog.vue?vue&type=script&lang=js&"
export * from "./ProtocolDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports